/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircleLetterC = createReactComponent("outline", "circle-letter-c", "IconCircleLetterC", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0", "key": "svg-1" }]]);

export { IconCircleLetterC as default };
//# sourceMappingURL=IconCircleLetterC.mjs.map
